import { render, staticRenderFns } from "./LeaveToPayrollPostingSetupGrid.vue?vue&type=template&id=63544fde"
import script from "./LeaveToPayrollPostingSetupGrid.vue?vue&type=script&lang=js"
export * from "./LeaveToPayrollPostingSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports